<top-banner variant="small"></top-banner>

<div class="main-content manage-competencies-page">
  <div class="card animated fadeIn pb-5">
    <div class="card-body mb-2">

      <card-section-header title="My Competencies" icon="fas fa-list"></card-section-header>

      <div *ngIf="!siteOwnersLoaded" class="temporary-information-message">
        <div class="small-spinner mb-4">
          <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
        </div>
        <div>
          <p class="mb-0">Loading your competencies by site owner</p>
        </div>
      </div>

      <div *ngIf="hasSiteOwnerLoadError" class="temporary-information-message mt-3 text-danger">
        <div>
          <i class="fas fa-exclamation-triangle"></i>
        </div>
        <div>
          <p class="mb-0">Error loading site owner lists to view competencies</p>
        </div>
      </div>

      <!-- page filters -->

      <div class="competency-filters-row" *ngIf="siteOwnerGroups.length">
        <div class="filter-flex-row">
          <div *ngIf="siteOwnerGroups.length >= 3">
            <label>Site Owner</label>
            <text-filter-box
              placeholder="Filter by site owner..."
              (onFilterTextChanged)="setSiteOwnerFilter($event)">
            </text-filter-box>
          </div>

          <filter-toggle-group
            label="Competency Status:"
            [options]="statusButtons"
            [value]="filters.status"
            (valueChange)="setStatusFilter($event)">
          </filter-toggle-group>

          <filter-toggle-group
            label="Competency Category:"
            [options]="categoryButtons"
            [value]="filters.category"
            (valueChange)="setCategoryFilter($event)">
          </filter-toggle-group>
        </div>
      </div>

      <div class="d-flex justify-content-end" *ngIf="siteOwnerGroups.length">
        <filter-summary-display [items]="activeFiltersSummary"></filter-summary-display>
      </div>

      <!-- page data -->

      <ng-container *ngIf="siteOwnerGroups.length">
        <div *ngIf="!visibleSiteOwnerGroups.length" class="empty-panel-state mt-4">
          <p class="empty-panel-state__message">No site owners match the current filters</p>
        </div>

        <div *ngFor="let siteOwnerGroup of visibleSiteOwnerGroups" class="stacked-group mt-5">
          <div
            class="d-flex align-items-center gap py-2"
            role="button"
            tabindex="0"
            (click)="toggleSiteOwnerGroup(siteOwnerGroup.siteOwnerId)"
          >
            <!-- toggle -->
            <div class="d-flex align-items-center">
              <i
                class="fa mr-3"
                [ngClass]="siteOwnerGroup.expanded ? 'fa-chevron-down' : 'fa-chevron-right'">
              </i>
              <span class="text-muted">{{ siteOwnerGroup.visibleCompetencies.length }} / {{ siteOwnerGroup.competencies.length }} competencies</span>
            </div>

            <!-- title -->
            <h5 class="sl-section-header mb-0">Site Owner: {{ siteOwnerGroup.fullName }}</h5>
          </div>

          <div *ngIf="siteOwnerGroup.expanded">
            <div *ngIf="siteOwnerGroup.viewState === 'loading'" class="mt-3">
              <div class="temporary-information-message">
                <div class="small-spinner mb-4">
                  <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                </div>
                <div>
                  <p class="mb-0">Loading your competencies</p>
                </div>
              </div>
            </div>

            <div *ngIf="siteOwnerGroup.viewState === 'ready'" class="competency-card-grid mt-3">
                <competency-card
                  *ngFor="let competency of siteOwnerGroup.visibleCompetencies"
                  [competency]="competency"
                  cardType="user-self"
                  [siteOwnerId]="siteOwnerGroup.siteOwnerId"
                  (updated)="onCardUpdated()">
                </competency-card>
            </div>

            <div *ngIf="siteOwnerGroup.viewState === 'empty'">
              <div class="empty-panel-state mt-3">
                <p class="empty-panel-state__message">No competencies added to your profile for this site owner</p>
              </div>
            </div>

            <div *ngIf="siteOwnerGroup.viewState === 'filtered-empty'">
              <div class="empty-panel-state mt-3">
                <p class="empty-panel-state__message">No competencies match the current filters for this site owner</p>
              </div>
            </div>

            <div *ngIf="siteOwnerGroup.viewState === 'error'" class="temporary-information-message mt-3 text-danger">
              <div>
                <i class="fas fa-exclamation-triangle"></i>
              </div>
              <div>
                <p class="mb-0">Could not load competencies for this site owner. Please refresh.</p>
              </div>
            </div>
          </div>

        </div>
      </ng-container>

    </div>
  </div>
</div>
